// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { N700 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import {
	LINE_WIDTH,
	ROTATION_FIRST_MARGIN,
	ROTATION_HEIGHT,
	ROTATION_MARGIN,
	SIDE_HEADER_WIDTH,
} from '../constants';

const NAME_PADDING = 8;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Container = styled.div<{
	size: 'small' | 'medium' | 'large';
	isFirstLastSame?: boolean;
	highlighted?: boolean;
}>(
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	(props) => ({
		alignItems: 'center',
		display: 'flex',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		height: `${ROTATION_HEIGHT[props.size]}px`,
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		paddingTop: `${ROTATION_MARGIN[props.size] / 2}px`,
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		paddingBottom: `${ROTATION_MARGIN[props.size] / 2}px`,
	}),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ isFirstLastSame, size }) =>
		isFirstLastSame !== true &&
		`
      &:first-of-type {
		${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
        padding-top: ${ROTATION_FIRST_MARGIN}px;
      }

      &:last-of-type {
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
        padding-bottom: ${ROTATION_MARGIN[size]}px;
      }
    `,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	(props) => ({
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		backgroundColor: props.highlighted
			? token('color.background.accent.teal.subtlest', '#E3FAFC')
			: 'transparent',
	}),
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Side = styled.div({
	alignItems: 'center',
	display: 'flex',
	justifyContent: 'center',
	height: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	minWidth: `${SIDE_HEADER_WIDTH + LINE_WIDTH}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	maxWidth: `${SIDE_HEADER_WIDTH + LINE_WIDTH}px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Inner = styled.div({
	position: 'relative',
	display: 'flex',
	width: '100%',
	height: '100%',
});

// TODO: check support of webkit-box (used to show ellipsis for multiline 'name')
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export const Name = styled.h6<{ slim: boolean }>((props) => ({
	color: token('color.text.subtlest', N700),
	overflow: 'hidden',
	padding: `0 ${NAME_PADDING}px`,
	textAlign: 'right',
	textOverflow: 'ellipsis',
	textTransform: 'none',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${SIDE_HEADER_WIDTH - 2 * NAME_PADDING}px`,
	'@supports (-webkit-line-clamp: 1)': {
		display: '-webkit-box',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		WebkitLineClamp: props.slim ? 2 : 4,
		WebkitBoxOrient: 'vertical',
	},
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SkeletonItemContainer = styled.div<{
	numberOfDays: number;
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
}>((props) => ({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	height: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `calc(100% / ${props.numberOfDays})`,
}));
